/**
 * 邮箱
 * @param {*} s
 */
export function isEmail(s) {
	return /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((.[a-zA-Z0-9_-]{2,3}){1,2})$/.test(s)
}

/**
 * 手机号码
 * @param {*} s
 */
export function isMobile(s) {
	return /^1[0-9]{10}$/.test(s)
}

/**
 * 电话号码
 * @param {*} s
 */
export function isPhone(s) {
	return /^([0-9]{3,4}-)?[0-9]{7,8}$/.test(s)
}

/**
 * URL地址
 * @param {*} s
 */
export function isURL(s) {
	return /^http[s]?:\/\/.*/.test(s)
}

export function isvalidUsername(str) {
	const valid_map = ['admin', 'editor']
	return valid_map.indexOf(str.trim()) >= 0
}

/* 合法uri */
export function validateURL(textval) {
	const urlregex =
		/^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
	return urlregex.test(textval)
}

/* 小写字母 */
export function validateLowerCase(str) {
	const reg = /^[a-z]+$/
	return reg.test(str)
}

/* 大写字母 */
export function validateUpperCase(str) {
	const reg = /^[A-Z]+$/
	return reg.test(str)
}

/* 大小写字母 */
export function validatAlphabets(str) {
	const reg = /^[A-Za-z]+$/
	return reg.test(str)
}

/* 验证pad还是pc */
export const vaildatePc = function () {
	const userAgentInfo = navigator.userAgent
	const Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod']
	let flag = true
	for (var v = 0; v < Agents.length; v++) {
		if (userAgentInfo.indexOf(Agents[v]) > 0) {
			flag = false
			break
		}
	}
	return flag
}

/**
 * validate email
 * @param email
 * @returns {boolean}
 */
export function validateEmail(email) {
	const re =
		/^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
	return re.test(email)
}

/**
 * 判断姓名是否正确
 */
export function validatename(name) {
	var regName = /^[\u4e00-\u9fa5]{2,4}$/
	if (!regName.test(name)) {
		return false
	}
	return true
}

/**
 * 判断是否为整数
 */
export function validatenum(num, type) {
	let regName = /[^\d.]/g
	if (type === 1) {
		if (!regName.test(num)) {
			return false
		}
	} else if (type === 2) {
		regName = /[^\d]/g
		if (!regName.test(num)) {
			return false
		}
	}
	return true
}

/**
 * 判断是否为小数
 */
export function validatenumord(num, type) {
	let regName = /[^\d.]/g
	if (type === 1) {
		if (!regName.test(num)) {
			return false
		}
	} else if (type === 2) {
		regName = /[^\d.]/g
		if (!regName.test(num)) {
			return false
		}
	}
	return true
}

/**
 * 判断是否为空
 */
export function validatenull(val) {
	if (typeof val === 'boolean') {
		return false
	}
	if (typeof val === 'number') {
		return false
	}
	if (val instanceof Array) {
		if (val.length === 0) {
			return true
		}
	} else if (val instanceof Object) {
		if (JSON.stringify(val) === '{}') {
			return true
		}
	} else {
		if (val === 'null' || val == null || val === 'undefined' || val === undefined || val === '') {
			return true
		}
		return false
	}
	return false
}

/**
 * 验证统一社会信用代码
 * @param { string } code 统一社会信用代码
 * 原文链接：https://blog.csdn.net/weixin_44116302/article/details/119518217
 * @param isJudgeFifteen
 **/
export function checkSocialCreditCode(code, isJudgeFifteen = true) {
	let isPass = true // 是否验证通过，默认通过，为true
	let errorMessage = '' // 错误信息

	// 空值直接返回false
	if (!code) {
		isPass = false
		errorMessage = '请填写 统一社会信用代码'
		return {
			isPass,
			errorMessage,
		}
	}
	if (isJudgeFifteen) {
		if (code.length === 15) {
			return {isPass, errorMessage}
		}
	}
	//18位及正则校验
	const reg = /^\w\w\d{6}\w{9}\w$/
	if (code.length !== 18 || !reg.test(code)) {
		isPass = false
		errorMessage = '不是有效的统一社会信用代码'
		return {
			isPass,
			errorMessage,
		}
	}
	return {
		isPass,
		errorMessage,
	}
}
